// Helper untuk mengurai URL Google Drive dan media URL lainnya
export const parseMediaUrl = (url, forceMediaType = null) => {
  if (!url || typeof url !== 'string') return { type: 'image', directUrl: '', rawUrl: '' };

  const trimmed = url.trim();

  // 1. Cek Google Drive
  const driveRegex = /(?:drive\.google\.com\/(?:file\/d\/|open\?id=|uc\?(?:export=download&)?id=)|docs\.google\.com\/file\/d\/)([a-zA-Z0-9_-]{25,})/;
  const driveMatch = trimmed.match(driveRegex);

  if (driveMatch && driveMatch[1]) {
    const fileId = driveMatch[1];
    return {
      type: forceMediaType || 'drive_video', // Default untuk Drive: drive_video jika video
      driveId: fileId,
      previewUrl: `https://drive.google.com/file/d/${fileId}/preview`,
      streamUrl: `https://drive.google.com/uc?export=download&id=${fileId}`,
      imageUrl: `https://lh3.googleusercontent.com/d/${fileId}`,
      rawUrl: trimmed
    };
  }

  // 2. Cek YouTube URL (watch, embed, shorts, youtu.be)
  // eslint-disable-next-line no-useless-escape
  const ytRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=|shorts\/)|youtu\.be\/)([^"&?/\s]{11})/;
  const ytMatch = trimmed.match(ytRegex);
  if (ytMatch && ytMatch[1]) {
    const videoId = ytMatch[1];
    return {
      type: 'youtube',
      youtubeId: videoId,
      embedUrl: `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&controls=0&playsinline=1&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`,
      thumbnailUrl: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
      rawUrl: trimmed
    };
  }

  // 3. Cek Video langsung berdasarkan ekstensi
  const isVideo = /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(trimmed);
  if (isVideo || forceMediaType === 'video') {
    return {
      type: 'video',
      directUrl: trimmed,
      rawUrl: trimmed
    };
  }

  // 4. Image / GIF biasa
  return {
    type: 'image',
    directUrl: trimmed,
    rawUrl: trimmed
  };
};
